/* eslint-disable sort-keys */
import {
    AGING_CATEGORY,
    AGING_TANK,
    APPELLATION,
    BRAND,
    COUNTRY,
    NET_VOLUME,
    PREMIUM_PACK,
    REGION,
    STRONGNESS,
    TEMPERATURE_FROM,
    TEMPERATURE_TO,
    YEAR,
} from 'modules/product-card/constants/characteristics';

const HEADER = [COUNTRY, REGION, APPELLATION, BRAND, AGING_CATEGORY, YEAR, NET_VOLUME, STRONGNESS, PREMIUM_PACK];
const DETAILED = [TEMPERATURE_FROM, TEMPERATURE_TO];
const TABLET = [...HEADER, ...DETAILED];

const DETAILED_ARMANYAK = [APPELLATION, AGING_TANK, YEAR, TEMPERATURE_FROM, TEMPERATURE_TO];
const TABLET_ARMANYAK = [...HEADER, ...DETAILED_ARMANYAK];

export const KONYAK_CHARACTERISTICS = {
    HEADER,
    DETAILED,
    TABLET,
};

export const ARMANYAK_CHARACTERISTICS = {
    HEADER,
    DETAILED: DETAILED_ARMANYAK,
    TABLET: TABLET_ARMANYAK,
};
